import { SxStyles } from '../../../../../../types';
import theme from '../../../../../../theme';
import { getResponsiveSize } from '../../../../../../utils';

export const VideoContentPanelStyle: SxStyles = {
  videoTabContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',

    '& .video-type-switch': {
      width: '100%',
      // mb: `calc(${theme.palette.propVars?.index} * 0.555)`,
      justifyContent: 'space-between',
      '& .mask-box ': {
        '& .MuiButton-root': {
          '& svg': {
            '&.union': {
              fill: theme.palette.neutral?.grey50,
            },
            '& .border': {
              stroke: theme.palette.neutral?.grey50,
            },
            '& .play': {
              fill: theme.palette.neutral?.grey50,
            },
          },
          '&.active': {
            color: theme.palette.neutral?.black,
            '& svg': {
              '&.union': {
                fill: theme.palette.neutral?.black,
              },
              '& .border': {
                stroke: theme.palette.neutral?.black,
              },
              '& .play': {
                fill: theme.palette.neutral?.black,
              },
            },
          },
        },
        '& .mask': {
          width: `calc(${theme.palette.propVars?.index} * 4.51)`,
        },
      },
    },

    '& .video-container': {
      pt: `calc(${theme.palette.propVars?.index} * 0.555)`,
      width: getResponsiveSize(468),
      height: getResponsiveSize(258),

      '& iframe': {
        borderRadius: theme.palette.propVars?.borderRadius,
      },
      '& .video-default': {
        height: '100%',

        '& img': {
          height: getResponsiveSize(152),
          width: getResponsiveSize(152),
          objectFit: 'cover',
          borderRadius: theme.palette.propVars?.borderRadius,
          margin: 'auto',
        },
      },
    },
  },
};
